import { Autorenew } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";
import { useRetryAllFailedDownloadsMutation } from "services/streamingApi/caseManager.api";
import { unwrappableActionSnackbarNotificationDecorator } from "utils/unwrappableActionSnackbarNotificationDecorator";
import { Dossier } from "types/Dossier";
import { useConfirm } from "material-ui-confirm";

export interface DossierRetryFailedButtonProps {
    dossier: Dossier;
}

export function DossierRetryFailedButton(props: DossierRetryFailedButtonProps) {
    const [retryAllFailedDownloads] = useRetryAllFailedDownloadsMutation();

    const confirm = useConfirm();

    return (
        <>
            <Tooltip title="Retry all failed recordings for this dossier">
                <Button
                    startIcon={<Autorenew />}
                    onClick={(event) => {
                        event.stopPropagation(); // Prevents parent onRowClick

                        confirm({
                            description: `Are you sure you want to retry all failed recordings for the dossier?`,
                            confirmationText: "Yes",
                            cancellationText: "No",
                        }).then((confirmResult) => {
                            if (confirmResult.confirmed) {
                                unwrappableActionSnackbarNotificationDecorator(
                                    retryAllFailedDownloads({
                                        id: props.dossier.id,
                                    }),
                                    `All failed recordings have been scheduled for retry`,
                                    `Failed to retry all failed recordings, please try again`,
                                    undefined,
                                    "info",
                                );
                            }
                        });
                    }}
                >
                    Retry failed
                </Button>
            </Tooltip>
        </>
    );
}
